import React from "react";
import "./msg.style.scss";

export const Msg = ({ content, contained, type = "primary" }) => {
  return (
    <div className="msg">
      <div
        className={`msg ${
          contained ? `msg__contained--${type}` : ""
        } msg--${type} `}
      >
        {content}
      </div>
    </div>
  );
};
